import React, { useState } from "react"
import btnStyle from "../../../../utils/buttonStyle.json"
import { useTranslation } from "react-i18next";
import { IoIosArrowRoundBack } from "react-icons/io";

type InputProps = {
    question: {
        helpText: string;
        type: string;
        _id: string;
        imgUrl: string;
        questionText: string;
        answers: {
            _id: string;
            answerText: string;
            answerImgUrl: string;
            linkedQuestionId: string;
            inputType: string;
            label: string;
            tag: string[];
            required: boolean;
        }[];
        cta: {
            _id: string;
            ctaText: string;
            ctaType: string;
            linkedQuestionId: string;
        }[];
    };
    handleBackBtn: () => void;
    updateUserResponse: (response: {
        questionType: string;
        questionText: string;
        nextQuestionId: string;
        _id: string;
        action?: string;
        answerResponse: object;
        selfieResponse: Array<object>;
        selfieID: string;
        userSelfie: string;
        timeStamp: number;
    }) => void;
    responseData: {
        questionType: string;
        questionText: string;
        nextQuestionId: string;
        _id: string;
        action?: string;
        answerResponse: object;
        selfieResponse: Array<object>;
        selfieID: string;
        userSelfie: string;
        timeStamp: number;
        backBtnConfig: object;
    };
};

const Input: React.FC<InputProps> = ({ question, handleBackBtn, updateUserResponse, responseData, inputs, backBtnConfig }) => {
    const { t } = useTranslation();
    const [userResponse, setUserResponse] = useState<Array<{ inputValue: string }>>(responseData?.answerResponse as Array<{ inputValue: string }> || []);
    const [error, setError] = useState<Array<string>>([])

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, answer: {
        label: string; tag: string[]; required: boolean;
    }, index: number) => {
        const inputData = {
            _id: e.target.id,
            inputType: e.target.type,
            inputValue: e.target.value,
            tag: answer.tag,
            inputLabel: answer?.label || "",
            inputRequired: answer.required !== undefined ? answer.required : true
        }
        setUserResponse(prevResponse => {
            const updatedResponse = [...prevResponse]
            updatedResponse[index] = inputData
            return updatedResponse
        })
    }

    const updateErrorMessage = (errorMessage: string, i: number) => {
        setError(prevError => {
            const updatedError = [...prevError]
            updatedError[i] = errorMessage
            return updatedError
        })
    }

    const validateInput = () => {
        let hasErrors = false;
        for (let i = 0; i < question.answers.length; i++) {
            const answer = question.answers[i];
            const userResponseValue = userResponse[i]?.inputValue;
            const isRequired = answer.required !== undefined ? answer.required : true;
            // If the field is required and no response is provided
            if (isRequired && (!userResponseValue || userResponseValue.trim() === '')) {
                updateErrorMessage(t("enterValue"), i);
                hasErrors = true;
                continue;
            }

            // Additional validation based on input type
            if (userResponseValue) {
                if (answer.inputType === "email" && !emailRegex.test(userResponseValue)) {
                    updateErrorMessage(t("enterValidEmail"), i);
                    hasErrors = true;
                } else if (answer.inputType === "number" && isNaN(Number(userResponseValue))) {
                    updateErrorMessage(t("enterValidNum"), i);
                    hasErrors = true;
                } else {
                    // Reset error message if input is valid
                    updateErrorMessage('', i);
                }
            }
        }
        return hasErrors;
    }

    const constructResponse = (cta: { _id?: string; ctaText?: string; ctaType: string; linkedQuestionId: string; }, skip = false) => {
        return {
            questionType: question.type,
            questionText: question.questionText,
            nextQuestionId: cta?.linkedQuestionId || "",
            _id: question._id,
            action: cta.ctaType,
            answerResponse: skip ? [] : userResponse,
            selfieResponse: [],
            selfieID: "",
            userSelfie: "",
            timeStamp: new Date().getTime()
        }
    }

    const handleSubmitBtn = (cta: { _id: string | undefined; ctaText: string | undefined; ctaType: string; linkedQuestionId: string; }) => {
        if (validateInput()) return;
        updateUserResponse(constructResponse(cta))
    }

    return (
        <>
            <button className="tangent_backbtn_custom tangent_backbtn_mob_custom tngnt-absolute tngnt-top-0 tngnt-self-start tngnt-m-4 tngnt-text-[30px]" onClick={handleBackBtn}>
                {backBtnConfig ? <img src={backBtnConfig.backBtn_icon} alt="back button" /> : <IoIosArrowRoundBack color="#929292" size={"3rem"} />}
            </button>
            <div className={`tangent_question_screen_custom tangent_question_screen_mob_custom tangent_${question._id}_question_screen_custom tangent_${question._id}_question_screen_mob_custom tngnt-flex tngnt-flex-col tngnt-items-center  tngnt-gap-4 sm:tngnt-gap-6 tngnt-p-3 sm:tngnt-p-6 tngnt-pt-16 sm:tngnt-pt-16 tngnt-justify-center tngnt-w-[100%]`} id={`comp_${question._id}`}>
                <div className={`tangent_global_style tangent_question_text tangent_question_text_custom tangent_question_text_mob_custom tangent_${question._id}_question_text_custom tangent_${question._id}_question_text_mob_custom tngnt-text-center tngnt-text-[20px] tngnt-ml-[15px] tngnt-mr-[15px] tngnt-w-[90%]`} dangerouslySetInnerHTML={{ __html: eval('`' + question.questionText + '`') }} />
                {question.imgUrl && <img className="tngnt-max-w-[inherit] tngnt-w-[100%] tngnt-max-h-[300px] tngnt-object-contain" src={question.imgUrl} alt="question image" />}
                <div className={`tangent_${question._id}_inputs_container_custom tangent_${question._id}_inputs_container_mob_custom tngnt-flex tngnt-flex-wrap tngnt-justify-center  tngnt-gap-4 tngnt-items-center tngnt-my-6 tngnt-w-[100%] sm:tngnt-w-[80%]`}>
                    {question.answers.map((answer, index) => (
                        <div className={`tangent_input_box_style_custom tngnt-flex tngnt-flex-col tngnt-gap-3 tngnt-w-[90%] sm:tngnt-w-[100%]`} key={answer._id}
                            id={answer._id}>
                            <label className="tangent_input_label_style_custom tngnt-text-sm tngnt-pb-1">{answer?.label}</label>
                            <input
                                id={answer._id}
                                className={"tangent_global_style tangent_input_style_custom tngnt-border-solid tngnt-border tngnt-border-black tngnt-leading-[24px] tngnt-text-[16px] tngnt-px-[8px] tngnt-py-[8px] " + (answer.inputType === "date" ? " tngnt-min-w-[94%]" : "")}
                                value={userResponse[index]?.inputValue || ''}
                                required={answer.required !== undefined ? answer.required : true}
                                type={answer.inputType}
                                placeholder={answer.answerText}
                                onChange={(e) => handleInputChange(e, answer, index)}
                            />
                            <span className="tangent_input_error_style_custom tngnt-text-base tngnt-mt-2 tngnt-text-red-600">{error[index]}</span>
                        </div>
                    ))}
                </div>
                {question.cta.map((cta) => (
                    <button
                        key={cta._id}
                        className={(cta.ctaType === "skip" ? `tangent_survey_skip_button_custom tangent_survey_skip_button_mob_custom tangent_${question._id}_survey_skip_button_custom tangent_${question._id}_survey_skip_button_mob_custom ` : `tangent_survey_next_button_custom tangent_primary_button_custom tangent_survey_next_button_mob_custom tangent_${question._id}_survey_next_button_custom tangent_${question._id}_survey_next_button_mob_custom `) + "tangent_global_style tngnt-p-2 tngnt-w-[90%] sm:tngnt-w-[50%] tngnt-text-[16px] " + btnStyle[cta.ctaType]}
                        onClick={cta.ctaType === "next" ? () => handleSubmitBtn(cta) : () => updateUserResponse(constructResponse(cta, true))}>
                        {cta.ctaText}
                    </button>
                ))}
                {
                    question?.helpText && <div className="tangent_global_style tangent_global_style_custom tangent_helpText_custom tngnt-text-center tngnt-p-2 tngnt-mt-6 tngnt-text-[14px] tngnt-leading-[20px]" dangerouslySetInnerHTML={{ __html: eval('`' + question.helpText + '`') }}></div>
                }
            </div >
        </>
    )
}

export default Input
